module.exports = __webpack_public_path__ + "img/product.9b19c600.png";